











import { Component, Prop, Vue } from 'vue-property-decorator'
import Content from '@/store/models/content'
import VContentBox from '@/components/VContentBox.vue'
import VueHorizontalList from 'vue-horizontal-list'

@Component({ components: { VContentBox, VueHorizontalList } })
export default class VContentList extends Vue {
  @Prop({ default: () => [] }) items!: Content[];
  @Prop() title!: string;

  private options = {
    responsive: [
      { end: 576, size: 1 },
      { start: 576, end: 768, size: 3 },
      { start: 768, end: 992, size: 4 },
      { size: 5 }
    ],
    list: {
      // 1200 because @media (min-width: 1200px) and therefore I want to switch to windowed mode
      windowed: 1200,
      // Because: #app {padding: 80px 24px;}
      padding: 24
    }
  }
}
